const MULTI_CHAR_MAP: ReadonlyArray<readonly [string, string]> = [
  ['щ', 'sch'],
  ['ш', 'sh'],
  ['ч', 'ch'],
  ['ц', 'ts'],
  ['ю', 'yu'],
  ['я', 'ya'],
  ['ё', 'yo'],
  ['ж', 'zh'],
  ['ъ', ''],
  ['ь', ''],
]

const SINGLE_CHAR_MAP: Readonly<Record<string, string>> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ы: 'y',
  э: 'e',
}

export const transliterateRuToLatin = (value: string): string => {
  let result = value.toLowerCase()
  for (const [from, to] of MULTI_CHAR_MAP) {
    result = result.replaceAll(from, to)
  }
  return [...result].map((char) => SINGLE_CHAR_MAP[char] ?? char).join('')
}

export const toAsciiFilenameSlug = (value: string): string => {
  const transliterated = transliterateRuToLatin(value.trim())
  const slug = transliterated
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/[^a-z0-9]+/gi, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
  return slug || 'restoran'
}
